import React from 'react'

const Arrow360Icon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='17'
    viewBox='0 0 16 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g mask='url(#mask0_3689_3048)'>
      <path
        d='M5.99992 14.2287L5.06659 13.2953L6.23325 12.0953C4.81103 11.9065 3.63881 11.5176 2.71659 10.9287C1.79436 10.3398 1.33325 9.66201 1.33325 8.89535C1.33325 7.97312 1.97492 7.18701 3.25825 6.53701C4.54159 5.88701 6.12214 5.56201 7.99992 5.56201C9.8777 5.56201 11.4583 5.88701 12.7416 6.53701C14.0249 7.18701 14.6666 7.97312 14.6666 8.89535C14.6666 9.58423 14.2971 10.2009 13.5583 10.7453C12.8194 11.2898 11.8555 11.6953 10.6666 11.962V10.5953C11.5221 10.3731 12.1805 10.0981 12.6416 9.77035C13.1027 9.44257 13.3333 9.1509 13.3333 8.89535C13.3333 8.53979 12.8583 8.11757 11.9083 7.62868C10.9583 7.13979 9.65547 6.89535 7.99992 6.89535C6.34436 6.89535 5.04159 7.13979 4.09159 7.62868C3.14159 8.11757 2.66659 8.53979 2.66659 8.89535C2.66659 9.16201 2.94992 9.48146 3.51659 9.85368C4.08325 10.2259 4.88881 10.5065 5.93325 10.6953L5.06659 9.82868L5.99992 8.89535L8.66658 11.562L5.99992 14.2287Z'
        fill='currentColor'
      />
    </g>
  </svg>
)

export default Arrow360Icon
